import React from 'react'

import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'

type ConnectionCountProps = {
  count: number
  connection: string
  onPress?: () => void
}
export const ConnectionCount = ({ count, connection, onPress }: ConnectionCountProps) => {
  return (
    <Pressable disabled={!onPress} onPress={onPress}>
      <Box testID={`${connection}Container`} flexDirection='column' align='center' width={66}>
        <Title size='md' bold color='v2black'>
          {count}
        </Title>
        <Text fontSize='sm' color='greyDark'>
          {connection}
        </Text>
      </Box>
    </Pressable>
  )
}
